<template>
<div>
  <RecordNotFound v-if="status_code==404" :message="status_message"></RecordNotFound>
  <div v-else class="credit-create-page">
    <!--  credit form component -->
    <RecurringInvoiceForm
      page="update"
      :submitted="submitted"
      :duplicatecode="duplicatecode"
      v-on:FormUpdate="FormUpdate = 1"
      v-on:onSubmit="onSubmit($event)"
    ></RecurringInvoiceForm>
  </div>
</div>
</template>

<script>
import RecurringInvoiceForm from "@/components/Form/RecurringInvoice/RecurringInvoiceForm"; // credit form for create and update
import store from "@/store/index"; // vuex store fucntion
import { notificationMixin } from "@/mixins/notification"; // global fucntion for calling notification
import { mapState } from "vuex"; // get data set in the state in vuex
import RecordNotFound from "@/pages/Error/RecordNotFound";
export default {
  name: "RecurringInvoiceUpdate",
  mixins: [notificationMixin], // call the glbal mixin fucntion
  components: {
    RecurringInvoiceForm,
    RecordNotFound
  },
  data() {
    return {
      FormUpdate: 0,
      duplicatecode: false,
      submitted: false,
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center" // notification design class
    };
  },
  methods: {
    onSubmit(data) {
      this.submitted = true;
      this.$store
        .dispatch("recurringinvoice/updateList", {
          id: this.$route.params.id,
          field: data
        })
        .then(() => {
          this.FormUpdate = 0; // to hide before route leave confirmation message

          if (this.code == 200) {
            //  show if invoice successfully created
            var saved_data = JSON.parse(data);
            if (saved_data.header_details.rec_inv_term_changed) {
              this.rec_inv_settings_details.internal_notes =
                saved_data.header_details.internal_notes;
            }
            if (saved_data.header_details.rec_inv_desc_changed) {
              this.rec_inv_settings_details.cus_inv_notes =
                saved_data.header_details.cus_inv_notes;
            }

            window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message: this.message,
              type: this.type,
              showCloseButton: true
            });
              //  show if invoice successfully created
            if(
                      this.RoutePermission(
                        false,
                        '',
                        'invoice',
                        'recurringinvoice',
                        'index'
                      )
                    )
                    {
            this.$router.push({
              name: "RecurringInvoiceView",
              params:{id:this.updated_id}
            });
          }
          else{
             this.$router.push({
              name: "RecurringInvoice"
            });
          }
          } else {
            //  showing eror message

            this.duplicatecode = true;
            this.submitted = false;
          }
        })
        .catch(() => {});
    }
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    store
      .dispatch(
        "sales/fetchSalesDetails",
        JSON.stringify({
          type: "recurring_invoice"
        })
      )
      .then(() => {
          store
      .dispatch("settings/fetchinvoicesettings", {
        stg_menu: "Recurring Invoice",
        stg_name: "rec_inv_settings_details"
      })
        next();
      });
  },
  beforeRouteLeave(routeTo, routeFrom, next) {
    //  alert message before leaving route to confirm unsave the changes
    if (this.FormUpdate == 1) {
      //  alert message to confirm
      const answer = window.confirm(
        "Do you really want to leave? you have unsaved changes!"
      );
      //  if okay move to next route
      if (answer) {
        next();
      } else {
        //  stay on the page
        next(false);
      }
    } else {
      //  move to the route if they had not done any changes
      next();
    }
  },
  updated: function() {},
  created() {
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },
  computed: {
    // mix this into the outer object with the object spread operator
    ...mapState({
      code: state => state.recurringinvoice.code,
      updated_id: state => state.recurringinvoice.updated_id,
      type: state => state.recurringinvoice.type,
      message: state => state.recurringinvoice.message,
      status_code: state => state.recurringinvoice.status_code, 
      status_message: state => state.recurringinvoice.status_message, 
      status_type: state => state.recurringinvoice.status_type 
    }),
    rec_inv_settings_details: {
      get() {
        return this.$store.state.permission.rec_inv_settings_details;
      },
      set(val) {
        this.$store.state.permission.rec_inv_settings_details = val;
      }
    }
  }
};
</script> 

<style>
</style>
